import React, { Component } from "react";

import Header from "parts/Header";
import HeroTeam from "parts/HeroTeam";
import AllTeam from "parts/AllTeam";
import Footer from "parts/Footer";
import Discuss from "parts/Discuss";

import { TeamMembers } from "json/landingPageData";

export default class TeamPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Header />
        <HeroTeam />
        <AllTeam data={TeamMembers} />

        {/* Missie Section */}
        <section id="missie" className="py-20 bg-white">
          <div className="container mx-auto px-6 lg:px-12">
            <div className="w-full md:w-3/4 mx-auto text-center">
              <h2 className="text-5xl sm:text-6xl text-theme-blue font-bold leading-tight mb-5">
                Onze Missie
              </h2>
              <p className="font-light text-xl text-gray-400 leading-relaxed mb-8">
                Bij <span className="text-theme-purple font-semibold">RevOnc</span> streven
                we ernaar om kankerpatiënten te ondersteunen in hun herstelproces door middel van
                innovatieve revalidatieprogramma&apos;s. We geloven dat herstel meer is dan alleen
                fysieke genezing; het gaat om het opbouwen van veerkracht, gemeenschap en een
                positieve toekomst.
              </p>
              <p className="font-light text-xl text-gray-400 leading-relaxed">
                Onze missie is om geavanceerde technologie te combineren met persoonlijke
                begeleiding, zodat elke patiënt
                toegang heeft tot de beste zorg die aansluit bij hun unieke behoeften.
              </p>
            </div>
          </div>
        </section>

        {/* Visie Section */}
        <section id="visie" className="py-20 bg-gray-50">
          <div className="container mx-auto px-6 lg:px-12">
            <div className="w-full md:w-3/4 mx-auto text-center">
              <h2 className="text-5xl sm:text-6xl text-theme-blue font-bold leading-tight mb-5">
                Onze Visie
              </h2>
              <p className="font-light text-xl text-gray-400 leading-relaxed mb-8">
                Wij streven ernaar het revalidatieproces te verbeteren voor kankerpatiënten met een
                focus op kwaliteit van leven en een snellere re-integratie in de samenleving. Onze
                visie is om revalidatie toegankelijker, effectiever en menselijker te maken, met een
                holistische benadering waarbij de patiënt altijd centraal staat.
              </p>
              <p className="font-light text-xl text-gray-400 leading-relaxed">
                Op lange termijn willen we ook preventieve zorg bieden, ondersteund door
                technologie,
                om het risico op kanker aanzienlijk te verlagen en zo een gezondere toekomst te
                creëren.
              </p>
            </div>
          </div>
        </section>

        <Discuss />
        <Footer />
      </>
    );
  }
}
